import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  question: "¿Necesito pagar por ChatGPT Plus (versión de pago)?",
  answer: "NO. Todo lo que enseñamos en el Masterkit funciona perfectamente con la versión gratuita de ChatGPT y otras herramientas gratuitas que te revelamos en la Toolbox."
}, {
  question: "¿Soy muy principiante, esto es para mí?",
  answer: "Absolutamente. El material está diseñado para llevarte de CERO a experto. No usamos jerga técnica complicada. Es copiar, pegar y ver resultados."
}, {
  question: "¿Cómo recibo el acceso al producto?",
  answer: "El acceso es inmediato y automático. En cuanto completas tu pago de $19.99, recibes un correo electrónico con tu enlace personal de descarga para todo el material."
}, {
  question: "¿En qué formato vienen los libros?",
  answer: "Todo el material viene en formato PDF digital de alta calidad, optimizado para leerse cómodamente en celular, tablet o computadora."
}, {
  question: "¿Qué pasa si no me gusta?",
  answer: "No hay problema. Tienes nuestra Garantía Blindada de 7 días. Si no sientes que vale 10 veces lo que pagaste, te devolvemos el dinero. Sin preguntas."
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);
  return <section className="py-24 bg-[#0a0a0a] relative z-10" data-id="element-252">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-253">
        <div className="text-center mb-12" data-id="element-254">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-255">
            PREGUNTAS FRECUENTES
          </h2>
          <p className="text-gray-400" data-id="element-256">Despejamos tus dudas antes de empezar.</p>
        </div>

        <div className="space-y-4" data-id="element-257">
          {faqs.map((faq, index) => <div key={index} className="border border-white/10 rounded-2xl bg-white/5 overflow-hidden transition-colors hover:border-cyan-500/30" data-id="element-258">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-259">
                <span className="text-lg font-medium text-white pr-8" data-id="element-260">
                  {faq.question}
                </span>
                <span className="flex-shrink-0 text-cyan-400" data-id="element-261">
                  {openIndex === index ? <Minus className="w-6 h-6" data-id="element-262" /> : <Plus className="w-6 h-6" data-id="element-263" />}
                </span>
              </button>

              <AnimatePresence data-id="element-264">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-265">
                    <div className="px-6 pb-6 text-gray-300 leading-relaxed border-t border-white/5 pt-4" data-id="element-266">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}